<script>
import forminput from "../formcomponet/forminput.vue";
import formdatetime from "../formcomponet/formdatetime.vue";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import satdosyaihaleilani from "@/models/satdosyaihaleilani";
export default {
  props: ["satdosyaId"],
  mixins: [apibtoast, apigeneric, satdosyaihaleilani],
  page: {
    title: "Firmalar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    forminput,
    Treeselect,
    formdatetime,
  },
  data() {
    return {
      title: this.$t("ofirma.Title"),
      items: [
        {
          text: this.$t("ofirma.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("ofirma.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("ofirma.Title"),
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      DefaultPage: 1,
      FormData: {},
      AddEdit: "",
    };
  },
  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "satdosyaihaleilani",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId,
      }).then((res) => {
        if (res.TotalCount != 0) {
          this.AddEdit = "Edit";
          this.FormData = res.Data[0];
        } else {
          this.AddEdit = "Add";
          let bellek = this.satdosyaihaleilaniData;
          this.FormData = bellek;
          this.FormData.Dosyaid = this.satdosyaId;
        }
        this.$emit("aktif_menu_title", this.$t("satdosyaihaleilani.Title"));
      });
    },
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("satdosyaihaleilani", this.FormData);
        } else {
          this.Update("satdosyaihaleilani", this.FormData);
        }
      }
    },
  },
};
</script>

<template>
  <Loader>
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">

            <Form @submit.prevent="onSubmit">
              <div class="row">
                <div class="col-md-6">
                  <forminput
                    :FormDataType="FormDataType.Teslimyeri"
                    :Value="FormData.Teslimyeri"
                    :v="$v.FormData.Teslimyeri"
                    @input="FormData.Teslimyeri = $event"
                  />
                </div>
                <div class="col-md-6">
                  <forminput
                    :FormDataType="FormDataType.Teslimtarihi"
                    :Value="FormData.Teslimtarihi"
                    :v="$v.FormData.Teslimtarihi"
                    @input="FormData.Teslimtarihi = $event"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <forminput
                    :FormDataType="FormDataType.Yapilacagiyer"
                    :Value="FormData.Yapilacagiyer"
                    :v="$v.FormData.Yapilacagiyer"
                    @input="FormData.Yapilacagiyer = $event"
                  />
                </div>
                <div class="col-md-6">
                  <formdatetime
                    :FormDataType="FormDataType.Ihaletarihsaati"
                    :Value="FormData.Ihaletarihsaati"
                    :v="$v.FormData.Ihaletarihsaati"
                    @input="FormData.Ihaletarihsaati = $event"
                  />
                  
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <forminput
                    :FormDataType="FormDataType.Ihalekayitnumarasi"
                    :Value="FormData.Ihalekayitnumarasi"
                    :v="$v.FormData.Ihalekayitnumarasi"
                    @input="FormData.Ihalekayitnumarasi = $event"
                  />
                </div>
                <div class="col-md-6">
                  <b-form-group
                    class="mb-3"
                    id="example text"
                    :label="FormDataType.Istenilenbelgeler.FieldTitle"
                    label-for="text"
                  >
                    <treeselect
                      :multiple="true"
                      :options="FormDataType.Istenilenbelgeler.ComboDataArray"
                      v-model="FormData.Istenilenbelgeler"
                      :class="{
                        'is-invalid': $v.FormData.Istenilenbelgeler.$error,
                      }"
                    />
                    <treeselect-value :value="FormData.Istenilenbelgeler" />

                    <div
                      v-if="$v.FormData.Istenilenbelgeler.$error"
                      class="invalid-feedback"
                    >
                      <span
                        v-if="$v.FormData.Istenilenbelgeler.required == false"
                        >{{ $t("ValidationMessage.required") }}</span
                      >
                    </div>
                  </b-form-group>
                </div>
              </div>

              <button class="btn btn-primary" type="submit">
                {{ $t("ofirma.AddEdit.Button") }}
              </button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </Loader>
</template>
